import { dateFriendly } from '../helpers/date';

/**
 * transform dashboard product status sku
 * @param {Object} sku
 * @returns {Object} sku
 */
export const transformDashboardSku = (data = {}) => {
	return {
		id: data.id || null,
		sku: data.itec_sku || null,
		name: data.name || '-',
		qty: data.total_stock_quantity || null,
		createdAt: data.created_at ? dateFriendly(data.created_at, 'DD MMM YYYY') : '-',
		updatedAt: data.updated_at ? dateFriendly(data.updated_at, 'DD MMM YYYY') : '-',
	};
};

/**
 * transform dashboard product status skus
 * @param {Array} skus
 * @returns {Array} skus
 */
export const transformDashboardSkus = (data = []) => {
	return data.map((item) => transformDashboardSku(item));
};

/**
 * transform dashboard product status
 * @param {Object} channel
 * @returns {Object} channel
 */
export const transformDashboardProductStatus = (data = {}) => {
	return {
		newSkus: transformDashboardSkus(data.new_skus),
		newSkusCount: data.new_skus_count,
		inactiveSkus: transformDashboardSkus(data.inactive_skus),
		inactiveSkusCount: data.inactive_skus_count,
	};
};

/**
 * transform dashboard overview
 * @param {Object} channel
 * @returns {Object} channel
 */
export const transformDashboardProductOverview = (data = {}) => {
	return {
		totalSkuITECCount: data.total_sku_itec_count || '-',
		onlineStockCount: data.total_online_stock_count || '-',
		activeSkuCount: data.total_active_sku_itec_count || '-',
		inactiveSkuCount: data.total_inactive_sku_itec_count || '-',
		eolSkuCount: data.total_eol_sku_itec_count || '-',
	};
};

/**
 * transform dashboard channel stock status
 * @param {Object} channel
 * @returns {Object} channel
 */
export const transformDashboardChannelStockStatus = (data = {}) => ({
	name: data.name,
	qty: data.total_channel_stock_quantity,
});

/**
 * transform dashboard fast move product
 * @param {Object} channel
 * @returns {Object} channel
 */
export const transformDashboardFastMoveProduct = (data = {}) => ({
	sku: data.itec_sku || null,
	name: data.name,
	qty: data.total_quantity,
});
